// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__xXXhi","listGridLayout":"List_listGridLayout__n5tly","listFlexLayout":"List_listFlexLayout__Xsklh"};